// extracted by mini-css-extract-plugin
export var base = "status-info-module--base--f8395";
export var end = "status-info-module--end--27f74";
export var error = "status-info-module--error--c40c1";
export var icon = "status-info-module--icon--fb689";
export var info = "status-info-module--info--8fc44";
export var success = "status-info-module--success--4982c";
export var title = "status-info-module--title--acffe";
export var warning = "status-info-module--warning--55181";